import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchServices } from "../../global-entities/globalEntitiesSlice";
import { fetchGeneralInformation } from "../general-information/generalInformationSlice";
import apiService from "../../../services/service";
import API_ROUTES from "../../../api-routes";

function useActiveService() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { status: generalInfoStatus, generalInformation } = useSelector(
    (state) => state.generalInformation,
  );

  const { status: servicesStatus, entityservices } = useSelector(
    (state) => state.globalEntities,
  );

  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeServices, setActiveServices] = useState([]);
  const [tempService, setTempService] = useState([]);
  const [isAudit, setIsAudit] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  useEffect(() => {
    const isAnyLoading =
      servicesStatus === "loading" || generalInfoStatus === "loading";
    const isAllCompleted =
      (servicesStatus === "succeeded" || servicesStatus === "failed") &&
      (generalInfoStatus === "succeeded" || generalInfoStatus === "failed");

    setIsLoading(isAnyLoading || !isAllCompleted);
  }, [servicesStatus, generalInfoStatus]);

  useEffect(() => {
    const data = generalInformation?.data;
    if (data) {
      setTempService(data.active_services);
      setActiveServices(data.active_services);
    }
  }, [generalInformation]);

  useEffect(() => {
    if (tempService.length > 0 && activeServices.length > 0) {
      const tempServiceids = tempService.map((x) => x.id);
      const serviceIds = activeServices.map((x) => x.id);
      const areSame =
        tempServiceids.every((id) => serviceIds.includes(id)) &&
        serviceIds.every((id) => tempServiceids.includes(id));
      setIsSaveDisabled(areSame);
    } else {
      setIsSaveDisabled(true);
    }
  }, [tempService, activeServices]);

  const handleEditClick = () => {
    setIsEdit(true);
  };
  const handleDiscardClick = () => {
    setActiveServices(tempService);
    setIsEdit(false);
    setIsUpdateLoading(false);
  };

  const handleChange = (service) => {
    setActiveServices((prevServices) => {
      const isSelected = prevServices.some(({ id }) => id === service.id);
      if (isSelected) {
        return prevServices.filter(({ id }) => id !== service.id);
      } else {
        return [...prevServices, service];
      }
    });
  };

  const removeService = () => {
    setIsConfirmModal(false);
    handleSubmit();
  };

  const handleSubmit = async () => {
    setIsUpdateLoading(true);
    const serviceIds = activeServices.map((x) => x.id);
    try {
      await apiService(API_ROUTES.UPDATE_ENTITY, "PUT", {
        replace: { id },
        body: JSON.stringify({ active_services: serviceIds }),
      });
      dispatch(fetchGeneralInformation(id));
      setSuccessMessage(`Active services successfully updated.`);
      setIsEdit(false);
    } catch (err) {
      console.log("Error updating entity:", err);
    } finally {
      setIsUpdateLoading(false);
    }
  };
  const handleSave = async () => {
    const removedItems = tempService.filter(
      (item) => !activeServices.some((active) => active.id === item.id),
    );
    if (removedItems.length > 0) {
      setIsConfirmModal(true);
    } else {
      handleSubmit();
    }
  };

  return {
    isEdit,
    isLoading,
    activeServices,
    entityservices,
    isAudit,
    isSaveDisabled,
    isUpdateLoading,
    isConfirmModal,
    successMessage,
    setSuccessMessage,
    setIsConfirmModal,
    handleEditClick,
    handleDiscardClick,
    setIsAudit,
    handleChange,
    removeService,
    handleSave,
  };
}
export default useActiveService;
